/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import { Input, FormControl, Button } from "@material-ui/core";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import HTMLViewer from "../Results/components/FileViewers/HTML/HTMLViewer";

import PDFViewer from "../Results/components/FileViewers/PDF/PDFViewer";

//import JSONViewer from '../Results/components/FileViewers/JSON/JSONViewer'
import Viewer from "../Results/components/FileViewers/Viewer";
import EXCELViewer from "../Results/components/FileViewers/TABLE/EXCEL/EXCELViewer";

import JSON_CONFIG from "../Results/components/Templates/JSON";

import JSONViewer from "../Results/components/FileViewers/JSON/JSONViewer";

import json_temp from "../Results/components/Templates/json_temp";
import ticket_temp from "../Results/components/Templates/ticket_temp";
import email_temp from "../Results/components/Templates/email_temp";

import test_results from "./testSearchResult.json";
import FlexForm from "../../traditional/FlexForm/FlexForm";

//import Cron from '@dealmeddevs/react-cron-generator'

import Cron from "react-cron-generator";
import "react-cron-generator/dist/cron-builder.css";
import { HEADER } from "react-cron-generator";

import wv_json from "../../assets/wv.json";
import bot_disp_conf from "../Results/components/Templates/bot_temp";
import params from "../../assets/param.json";

import Scheduler from "../Scheduler/Scheduler";

import { Avatar, Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import ImageViewer from '../Results/components/FileViewers/IMAGE/ImageViewer'
import testocrJpg from '../../assets/testocr.jpg'
import testocrPng from '../../assets/testocr.png'
import Actions from "../../fluid/Actions/ActionFactory";

import RangeSelector from '../Analytics/components/RangeSelector/RangeSelector'

import BotStats from '../Analytics/Screens/BotStats'
import ChartComponent from '../Analytics/components/Charts/ChartComponent'

import FlexFormGenerator from '../FlexFormGenerator/FlexFormGenerator'
import { Paper } from '@material-ui/core'

const styles = (theme) => ({});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    margin: {
      margin: "16px",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#ff9100",
    },
  },
});

const dummyResult = {
  result: {
    wv_id_str: {
      IU_key: {
        ws_id: "",
        containment: { rda_id: "" },
        user_friendly_name: "servicenow",
      },
      iu_record_id: "",
    },

    wv_field_list: [
      {
        name: "id",
        type: "String",
        value: {
          number: null,
          text: "D89563",
          list: null,
          boolean: null,
        },
      },

      {
        name: "title",
        type: "String",
        value: {
          number: null,
          text: "Airpods are not working as headset",
          list: null,
          boolean: null,
        },
      },

      {
        name: "description",
        type: "String",
        value: {
          number: null,
          text:
            "I tried connecting to Airpods in UBbuntu and thats not working.<br/>I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/><br/><br/>.I tried connecting to Airpods in UBbuntu and thats not working.<br/><br/><br/><br/>connecting to Airpods in UBbuntu and thats not working.connecting to Airpods in UBbuntu and thats not working.",
          list: null,
          boolean: null,
        },
      },

      {
        name: "main_module",
        type: "String",
        value: {
          number: null,
          text: "Marketing",
          list: null,
          boolean: null,
        },
      },
      {
        name: "sub_module",
        type: "String",
        value: {
          number: null,
          text: "Digital",
          list: null,
          boolean: null,
        },
      },
    ] /* wv_field_list */,

    iu_record_src_info: {
      iu_record_content_type: "ticket",
      iu_record_nav_info: {
        source: [
          { level: "0", annotation: "", link: "" },
          { level: "1", annotation: "", link: "" },
        ],
        location: {
          annotation: "",
          position: "",
        },
      } /* iu_record_nav_info */,
    } /* iu_record_src_info */,
  } /* iu_record_world_view */,
};

const formConfig = [
  {
    name: "Highlight Documents",
    key : "highlight",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: false
    },
    elements: null,
    component: "switch",
    component_params: [
      {
        name : "helper_text",
        value : {
          number: null,
          text: "Highlight relevant sections in the document.",
          list: null,
          boolean: null
        }
      }
    ]
  },
  {
    name: "Allow Download",
    key : "download",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: null
    },
    elements: null,
    component: "switch",
    component_params: [
      {
        name : "helper_text",
        value : {
          number: null,
          text: "Allow downloading documents.",
          list: null,
          boolean: null
        }
      }
    ]
  },
  {
    name : "Number",
    key : "number",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: null
    },
    elements: null,
    component: "number",
    component_params: [
      {
        name : "helper_text",
        value : {
          number: null,
          text: "Number Input",
          list: null,
          boolean: null
        }
      }
    ]
  },
  {
    name : "Text",
    key : "text",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: null
    },
    elements: null,
    component: "number",
    component_params: [
      {
        name : "helper_text",
        value : {
          number: null,
          text: "Number Input",
          list: null,
          boolean: null
        }
      },
      {
        name : "mandatory",
        value : {
          number: null,
          text: null,
          list: null,
          boolean: true
        }
      }
    ]
  },
  {
    name : "Text2",
    key : "text",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: null
    },
    elements: null,
    component: "number",
    component_params: [
      {
        name : "helper_text",
        value : {
          number: null,
          text: "Number Input",
          list: null,
          boolean: null
        }
      }
    ]
  }
]

// const formConfig = [
//   {
//     name: "From Date",
//     value: {
//       number: null,
//       text: null,
//       list: null,
//       boolean: null
//     },
//     elements: null,
//     component: "date",
//     component_params: [],
//   },
//   {
//     name: "Highlight Documents",
//     value: {
//       number: null,
//       text: null,
//       list: null,
//       boolean: null
//     },
//     elements: null,
//     component: "switch",
//     component_params: [
//       {
//         name : "helper_text",
//         value : {
//           number: null,
//           text: "Highlight relevant sections in the document.",
//           list: null,
//           boolean: null
//         }
//       }
//     ]
//   },
//   {
// 		"name" : "Country",
// 		"component" : "select",
// 		"component_params" : [
// 			{
// 				"name" : "label",
// 				"value" : {
// 					"number": null,
// 					"text": "Countries",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "helper_text",
// 				"value" : {
// 					"number": null,
// 					"text": "Choose Country",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "options",
// 				"value" : {
// 					"number": null,
// 					"text": null,
//           "list" : [
//             {
//               "value" : "IND",
//               "annotation" : null
//             },
//             {
//               "value" : "AUS",
//               "annotation" : "Australia"
//             }
//           ],
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error",
// 				"value" : {
// 					"number": null,
// 					"text": null,
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error_message",
// 				"value" : {
// 					"number": null,
// 					"text": "No Country selected",
// 					"list": null,
// 					"boolean": null
// 				}
// 			}

// 		],
// 		"elements" : null,
// 		"value" : {
// 			"number": null,
// 			"text": null,
// 			"list": null,
// 			"boolean": null
// 		}
//   },
//   {
// 		"name" : "Time Zone of the data server",
// 		"component" : "timezone",
// 		"component_params" : [
// 			{
// 				"name" : "label",
// 				"value" : {
// 					"number": null,
// 					"text": "Countries",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "helper_text",
// 				"value" : {
// 					"number": null,
// 					"text": "Choose Country",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "options",
// 				"value" : {
// 					"number": null,
// 					"text": null,
// 					"list": ["$fieldsInScope"],
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error",
// 				"value" : {
// 					"number": null,
// 					"text": null,
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error_message",
// 				"value" : {
// 					"number": null,
// 					"text": "No Country selected",
// 					"list": null,
// 					"boolean": null
// 				}
// 			}

// 		],
// 		"elements" : null,
// 		"value" : {
// 			"number": null,
// 			"text": null,
// 			"list": null,
// 			"boolean": null
// 		}
//   },
//   {
// 		"name" : "Category List",
// 		"component" : "text_list",
// 		"component_params" : [		
// 			{
// 				"name" : "helper_text",
// 				"value" : {
// 					"number": null,
// 					"text": "Enter list here",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error",
// 				"value" : {
// 					"number": null,
// 					"text": null,
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error_message",
// 				"value" : {
// 					"number": null,
// 					"text": "List cannot be empty",
// 					"list": null,
// 					"boolean": null
// 				}
// 			}
// 		],
// 		"elements" : null,
// 		"value" : {
// 			"number": null,
// 			"text": null,
// 			"list": null,
// 			"boolean": null
// 		}
//   },
//   {
//     name: "Email Event",
//     value: {
//       number: null,
//       text: null,
//       list: null,
//       boolean: null
//     },
//     elements: null,
//     component: "event",
//     component_params: []
//   },
//   {
// 		"name" : "Experiences",
// 		"component" : "group",
// 		"component_params" : null,
// 		"elements" : [
// 			[
//         {
//           name: "Value",
//           value: {
//             number: null,
//             text: null,
//             list: null,
//             boolean: null
//           },
//           elements: null,
//           component: "text",
//           component_params: []
//         },
//         {
//           name: "Annotation",
//           value: {
//             number: null,
//             text: null,
//             list: null,
//             boolean: null
//           },
//           elements: null,
//           component: "text",
//           component_params: []
//         }
// 			]
// 		],
// 		"value" : {
// 			"number": null,
// 			"text": null,
// 			"list": null,
// 			"boolean": null
// 		}
//   },
//   {
//     name : "Multi Select Conuntries",
//     component : "multi_select",
//     component_params : [
//       {
// 				"name" : "label",
// 				"value" : {
// 					"number": null,
// 					"text": "Countries",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "helper_text",
// 				"value" : {
// 					"number": null,
// 					"text": "Choose Country",
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "options",
// 				"value" : {
// 					"number": null,
// 					"text": null,
//           "list" : [
//             {
//               "value" : "IND",
//               "annotation" : "India"
//             },
//             {
//               "value" : "AUS",
//               "annotation" : "Australia"
//             }
//           ],
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error",
// 				"value" : {
// 					"number": null,
// 					"text": null,
// 					"list": null,
// 					"boolean": null
// 				}
// 			},
// 			{
// 				"name" : "error_message",
// 				"value" : {
// 					"number": null,
// 					"text": "No Country selected",
// 					"list": null,
// 					"boolean": null
// 				}
// 			}
//     ],
//     elements : null,
//     value : {
//       number: null,
//       text: null,
//       list: null,
//       boolean: null
//     }
//   }
// ];

const imageViewerProps = {
  file_src : testocrJpg,
  file_name: "Test OCR JPG",
  width: "250px",
  height: "300px"
}

const chart_config = {
  name : "Script Status Trend",
  charts : [
      {
          type : 'bar',
          name : 'Completed',
          param_key : 'status',
          param_value : 'Completed',
          value_key : 'value',
          color : 0
      },
      {
          type : 'area',
          name : 'Aborted',
          param_key : 'status',
          param_value : 'Aborted',
          value_key : 'value',
          color : 3
      }
  ]
}

const record_keys = [{name: "Ticket ID"}, {name: "Short Description"}, {name: "Description"}, {name: "Resolution"}, {name: "Category"}]

class TestScreen extends Component {
  state = {
    // type: "pdf",
    // htmlContent: "",
    // //url: "http://localhost:9000/DELOutput.html",
    // url:
    //   "http://3.236.15.228:8000/1595623777225_InfoChannel Architekture/InfoChannel Architekture.html",
    // location: "del-location-421",
    // viewer: "html",
    // height: "700px",
    // enteredLocation: null,
    // drl_url: "http://3.236.15.228:8000/1595623777225_InfoChannel Architekture/",
    // cron_value: "",
    // schedule: {
    //   date_time: null,
    //   recursive: {
    //     start_date_time: "",
    //     end_date_time: "",
    //     cron_expr: "",
    //   },
    // },
    formConfig: [],
    write_fields : [],
    // validation_status : false
  };

  componentDidMount = () => {
  //   Actions('http_request', {
  //     url : '/sainapse/bot/additionalparameter',
  //     method : 'get',
  //     data : {
        
  //     }
  // }).then(res => {
  //   console.log("response sainapse")
  //   console.log(res.data.result)
  // }).catch(err => {
      
  // }) 

  };

  componentWillMount(){
    //this.setState({ ...this.state, formConfig: formConfig})
    //this.testCubeApi()
  }

  componentDidUpdate (prevProps, prevState) {

  }

  
  handleChange = (event) => {
    if (event.key === "Enter") {
      let location = event.target.value;
      this.setState(
        { location: location, enteredLocation: event.target.value },
        () => console.log("VIewer location : ", this.state.location)
      );
    }
  };

  // renderTickets = () => {
  //   let tickets = test_results.result[0].response.result.map(result => {
  //     return <JSONViewer config = {ticket_temp} record = {result}/>
  //   })
  //   return tickets
  // }

  // render() {
  //     let config = {  result: dummyResult.result }
  //     let record = test_results.result[0].response.result[0]

  //     return (
  //       <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row'}}>
  //         <JSONViewer config = {json_temp} record = {{}} edit = {true}/>
  //         <JSONViewer config = {ticket_temp} record = {{}} edit = {true}/>
  //         <JSONViewer config = {email_temp} record = {{}} edit = {true}/>

  //       </div>
  //     )
  // }

  setForm = (form) => {
    console.log("form to set");
    console.log(form);
  };

  setCron = (event) => {
    this.setState({ cron_value: event });
  };

  renderBotViewer = () => {
    var toPX = require("to-px");
    return Viewer(
      {
        id: "",
        viewer: bot_disp_conf.viewer,
        config: bot_disp_conf,
        record: wv_json,
        edit: false,
      },
      {
        width: toPX("65vw"),
        height: toPX("90vh"),
        wv_url: "",
        drl_url: "",
        drl_result: "",
        search_string: "",
        file_path: "",
        location_index: 0,
        params: params,
      }
    );
  };

  setSchedule = (schedule) => {
    this.setState({
      ...this.state,
      schedule: schedule,
    });
  };

  updateForm = (form) => {
    console.log("Update FlexForm :", form)
    this.setState({...this.state, formConfig: form}, () => console.log('Adaptor State : ', this.state))
  }

  triggerSchedule = () => {

    Actions('http_request', {
      url : '/sainapse/schedule',
      method : 'post',
      data : {
        "cron_expression": "0 0 21 ? * * *",
        "end_time": "2020-10-08T20:45:00+05:30",
        "group": "Workflow_execution",
        "name": "Schedule_WF_Test",
        "start_time": "2020-10-01T20:45:00+05:30",
        "workflow_request": "Test WF Local"
      }
  }).then(res => {
    console.log("response sainapse")
    console.log(res.data.result)
  }).catch(err => {
      
  })   
    // Actions("http_request", {
    //   url: '/sainapse/schedule',
    //   method: "post",
    //   data: payLoad,
    //   }).then((response) => {
    //     console.log("response sainapse")
    //     console.log(response.data.result)
    //   })
    //   .catch((err) => {
    //     console.log("error while fetching logged in user info", err);
    //   });
    

  }

  updateWriteFields = (form) => {
    this.setState({...this.state, write_fields : form, formConfig : form})
  }

  render() {
    const { classes } = this.props;
    return (
     
      <div style = {{ display:"flex", flexDirection: "column"}}> 
        <ThemeProvider theme={blue_theme}>  
          {/* <FlexForm 
            config = { this.state.formConfig  } 
            fields_in_scope = {[]} 
            update_parent = {(form) => this.updateForm(form)}
            validate = {true}
            validation_status = {(status) => this.setState({...this.state, validation_status : status})}
            submit = {(form) =>  this.setForm(form)} 
            grid_element_width = "96%"
          />     */}
          <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
            <div style = {{width : '45%', height : '500px'}}>
              <FlexFormGenerator config = {this.state.write_fields} heading = "Generate Editable Form" binding_keys = {record_keys} updateParent = {(form) => this.updateWriteFields(form)}/>
            </div>
            <div style = {{width : '45%', height : '100%', marginTop : '30px', marginLeft : '10px'}}>
              <Paper style = {{width : '100%', padding : '10px'}}>
                <FlexForm config = {this.state.formConfig} fields_in_scope = {[]} update_parent = {(form) => this.updateForm(form)} grid_element_width = "50%"/>
              </Paper>
            </div>
          </div>
        </ThemeProvider>
      </div>
    );
  }
}

export default withStyles(styles)(TestScreen);
